module.exports = __webpack_public_path__ + "img/nullSearch.de1f8763.svg";